import { getDeliverySpot } from 'src/utils/firebase/firebase-short-cut';
import useSWRImmutable from 'swr/immutable';

const useSWRDeliverySpot = (deliverySpotId: string | null) => {
  const {
    data: deliverySpot,
    isLoading,
    error,
    mutate,
  } = useSWRImmutable(
    deliverySpotId ? `deliverySpot-${deliverySpotId}` : null,
    () => getDeliverySpot(deliverySpotId as string)
  );

  return {
    deliverySpot,
    isLoading,
    error,
    refresh: () => mutate(),
  };
};

export default useSWRDeliverySpot;
